import list from './list'
import primary from './primary'
import create from './create'
import update from './update'
import clone from './clone'
import promote from './promote'
import remove from './remove'
import createGroup from './createGroup'
import removeGroup from './removeGroup'

export default {
  list,
  primary,
  create,
  update,
  clone,
  promote,
  remove,
  createGroup,
  removeGroup,
}
